import { Outlet } from "react-router-dom";
import { isServiceDown } from "util/constent";

export default function Main() {
  return (
    <main className={isServiceDown ? "notice" : ""}>
      <Outlet />
    </main>
  );
}
